import ProxyTeamReport from './proxy-team-report.web';

export default ProxyTeamReport;
